"use client";

import { useMutation } from "@tanstack/react-query";
import type { SubmitPublicFeedbackRequest } from "@/generated/fastapi";
import { submitPublicFeedback } from "../api/submitPublicFeedback";

export default function useSubmitPublicFeedbackMutation(token: string) {
  return useMutation({
    mutationFn: (request: SubmitPublicFeedbackRequest) =>
      submitPublicFeedback(token, request),
  });
}
